import Request from './request';

const unauthorizedRequest = new Request();

export default unauthorizedRequest;
